
export default function Tabs(theme) {

  return {
    MuiTab: {
      styleOverrides: {
        root: {
          marginTop:5,
          marginLeft:5,
          marginRight:5,
          padding: 5,
          letterSpacing: 1,
          fontWeight: theme.typography.fontWeightMedium,
         backgroundColor: theme.palette.dark,
         color: theme.palette.text.disabled,
         borderTopLeftRadius: "5px",
         borderTopRightRadius: "5px",
         indicator: {
          height: 5,
        },
         "&:hover": {
          border: 0,
          borderBottom: "2px solid",
        },
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.text.white,
            borderTopRadius: "12px",
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.text.disabled, borderTopRadius: "12px"
          },
          '&:not(:last-of-type)': {
            marginRight: theme.spacing(1),
          },
          '@media (min-width: 600px)': {
            minWidth: 48,
          },
        },
        labelIcon: {
          minHeight: 48,
          flexDirection: 'row',
          '& > *:first-of-type': {
            marginBottom: 0,
            marginRight: theme.spacing(1),
          },
        },
        wrapper: {
 
          flexDirection: 'row',
          whiteSpace: 'nowrap',
        },
        textColorInherit: {
          opacity: 2,
          color: theme.palette.text.white,
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
          backgroundColor: theme.palette.primary.dark,
       
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 48,
          borderRadius: '50%',
        },
      },
    },
  };
}
